import { render, staticRenderFns } from "./ManualSocials.vue?vue&type=template&id=52250f0b&"
import script from "./ManualSocials.vue?vue&type=script&lang=js&"
export * from "./ManualSocials.vue?vue&type=script&lang=js&"
import style0 from "./ManualSocials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports